import styled from "styled-components";

export const Container = styled.div`
  height: 100%;
`;

export const Content = styled.div`
  margin: 1rem 0 0;

  @media (min-width: 768px) {
    margin: 2rem 0 0 2rem;
    height: calc(100% - 90px);
  }
`;

export const SelectOption = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0.75rem;
  box-shadow: 0px 1px 2px 2px rgba(0, 0, 0, 0.1);

  > button {
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const Option = styled.button`
  color: ${({ theme }) => theme.colors.primary};
  border: 0;
  background-color: transparent;

  p {
    font-size: 0.875rem;
    margin: 0;
  }

  svg {
    width: 20px;
    height: 20px;
    margin-right: 0.125rem;
  }
`;

export const CardContent = styled.div`
  box-shadow: 0px 1px 2px 2px rgba(0, 0, 0, 0.1);
  max-width: 480px;
  width: 100%;

  & + div {
    margin-left: 2rem;
  }

  @media (min-width: 768px) {
    max-height: 100%;
    overflow-y: scroll;
  }
`;

export const BodyContent = styled.div`
  padding: 1rem;
  margin-top: 1rem;
`;

export const ItemContent = styled.div`
  display: flex;
  justify-content: space-between;

  & + div {
    margin-top: 1rem;
  }

  &:last-child {
    flex-direction: column;

    span {
      margin-top: 0.5rem;
      line-height: 24px;
      margin-left: 0;
    }
  }

  p {
    color: ${({ theme }) => theme.colors.gray};
    display: flex;
    justify-content: space-between;
    word-break: break-all;
  }

  span {
    color: ${({ theme }) => theme.colors.black};
    margin-left: 0.5rem;
  }
`;

export const ItemMap = styled.div`
  width: 100%;
  height: 280px;

  > div {
    width: 100%;
    height: 100%;
  }
`;

export const PictureFarmer = styled.div`
  position: relative;
  height: 220px;

  > img {
    width: 100%;
    height: 220px;
    object-fit: cover;
  }
`;

export const NameFarmer = styled.div`
  position: absolute;
  left: 0;
  bottom: 0px;
  background-color: rgba(0, 0, 0, 0.5);
  height: 50px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  width: 100%;
  display: flex;
  align-items: center;

  > p {
    margin-left: 1rem;
    color: ${({ theme }) => theme.colors.white};
    font-size: 1rem;
  }
`;

export const Line = styled.div`
  height: 1px;
  margin: 1.5rem 0;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.gray};
  opacity: 0.2;
`;

export const DownloadFile = styled.a`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.gray};
  text-decoration: none;
  box-shadow: 0px 1px 2px 2px rgba(0, 0, 0, 0.1);
  padding: 1rem;
  border-radius: 20px;
  margin-top: 0.5rem;

  svg {
    width: 25px;
    height: 25px;
    color: ${({ theme }) => theme.colors.transactionPrimary};
    margin-right: 1rem;
  }

  > div {
    span {
      font-size: 0.75rem;
    }

    p {
      font-size: 0.875rem;
      text-overflow: ellipsis;
    }
  }
`;

export const TitleSanitaryPlan = styled.p`
  color: ${({ theme }) => theme.colors.gray};
  font-size: 0.875rem;
`;

export const SanitaryPlan = styled.div``;
